import { getCommercial, postCommercial, putCommercial } from "../.";
import {
  CancelApplicationDto,
  CardApplicationDocument,
  CardApplicationDto,
  CardholderBenefitsDto,
  ChangeApplicationProductDto,
  SignatoriesDto,
} from "../generated-types";

const startFirstCardApplication = async (
  request: CardApplicationDto,
  baaRef: string,
): Promise<string> => {
  return postCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications?type=first`,
    request,
  );
};

const updateFirstCardholder = async (
  request: CardApplicationDto,
  baaRef: string,
  caRef: string,
): Promise<void> => {
  return putCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}?type=first`,
    request,
  );
};

const startAdditionalCardApplication = async (
  request: CardApplicationDto,
  baaRef: string,
): Promise<string> => {
  return postCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications?type=additional`,
    request,
  );
};

const updateAdditionalCardholder = async (
  request: CardApplicationDto,
  baaRef: string,
  caRef: string,
): Promise<void> => {
  return putCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}?type=additional`,
    request,
  );
};

const saveCardholderBenefits = async (
  request: CardholderBenefitsDto,
  baaRef: string,
  caRef: string,
): Promise<void> => {
  return postCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/benefits`,
    request,
  );
};

const saveFirstCardSignatoryData = async (
  request: SignatoriesDto,
  baaRef: string,
  caRef: string,
): Promise<void> => {
  return postCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/choose-signatories?type=first`,
    request,
  );
};

const saveAdditionalCardSignatoryData = async (
  request: SignatoriesDto,
  baaRef: string,
  caRef: string,
): Promise<void> => {
  return postCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/choose-signatories?type=additional`,
    request,
  );
};

const signFirstCardApplication = (
  baaRef: string,
  caRef: string,
  language: string,
): Promise<string> => {
  return getCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/sign`,
    { language },
    false,
  );
};

const query = (
  baaRef: string,
  caRef: string,
): Promise<CardApplicationDocument> => {
  return getCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}`,
  );
};

const readyForSigningFirstCardApplication = (
  baaRef: string,
  caRef: string,
): Promise<void> => {
  return postCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/confirm-pdf-details?type=first`,
  );
};

const readyForSigningAdditionalCardApplication = (
  baaRef: string,
  caRef: string,
): Promise<void> => {
  return postCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/confirm-pdf-details?type=additional`,
  );
};

const cancel = async (
  baaRef: string,
  caRef: string,
  request: CancelApplicationDto,
): Promise<void> => {
  return postCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/cancel`,
    request,
  );
};

const changeProduct = async (
  baaRef: string,
  caRef: string,
  request: ChangeApplicationProductDto,
): Promise<void> => {
  return postCommercial(
    `/protected/basicAccountApplications/${baaRef}/cardApplications/${caRef}/change-product`,
    request,
  );
};

const CardApplicationAPI = {
  startFirstCardApplication,
  updateFirstCardholder,
  startAdditionalCardApplication,
  updateAdditionalCardholder,
  saveCardholderBenefits,
  saveFirstCardSignatoryData,
  saveAdditionalCardSignatoryData,
  readyForSigningFirstCardApplication,
  readyForSigningAdditionalCardApplication,
  signFirstCardApplication,
  query,
  cancel,
  changeProduct,
};

export default CardApplicationAPI;
